import { Injectable } from '@angular/core';

@Injectable()
export class StatusService {

  // every thing in here is caps
  // null means no button
  // status should never be null
  // questions goto Chris Uth
  token: string = null;
  org: string = null;
  error: string;
  dialogRef: any;

  constructor() {

  }

  private STATUS = {

    SET_HEARING:{

      TWOTHREE: {

        CLERK: {
          STATUS: 'Case number appointed',
          BUTTON: 'hearing'
        },
        PETITIONER: {
          STATUS: 'Waiting for hearing date',
          BUTTON: null
        },
        GUARDIAN: {
          STATUS: 'Waiting for hearing date',
          BUTTON: null
        },
        HEIR: {
          STATUS: 'Waiting for hearing date',
          BUTTON: null
        },
        GUARDIANADLITEM:{
          STATUS: 'Documents uploaded',
          BUTTON: null
        },
        ATTORNEY: {
          STATUS: 'Waiting for hearing date',
          BUTTON: null
        }

      }
    },

    RESUBMITTED_FOR_CLERK: {
      TWOTHREE: {

        CLERK: {
          STATUS: 'Resubmitted form review',
          BUTTON: 'Rereview'
        },
        PETITIONER: {
          STATUS: 'Resubmitted to court',
          BUTTON: null
        },
        GUARDIAN: {
          STATUS: 'How are you seeing this? Contact Support',
          BUTTON: null
        },
        HEIR: {
          STATUS: 'Resubmitted to court',
          BUTTON: null
        },
        ATTORNEY: {
          STATUS: 'Resubmitted to court',
          BUTTON: null
        }
      }
    },

    FILED_FOR_CLERK: {

      TWOTHREE: {

        CLERK: {
          STATUS: 'Form review',
          BUTTON: 'Review'
        },
        PETITIONER: {
          STATUS: 'Submitted to court',
          BUTTON: null
        },
        GUARDIAN: {
          STATUS: 'How are you seeing this? Contact Support',
          BUTTON: null
        },
        HEIR: {
          STATUS: 'Submitted to court',
          BUTTON: null
        },
        ATTORNEY: {
          STATUS: 'Submitted to court',
          BUTTON: null
        }

      },
      TWOFOUR: {

        CLERK: {
          STATUS: 'Case number appointed',
          BUTTON: 'hearing'
        },
        PETITIONER: {
          STATUS: 'Waiting for hearing date',
          BUTTON: null
        },
        GUARDIAN: {
          STATUS: 'Waiting for hearing date',
          BUTTON: null
        },
        HEIR: {
          STATUS: 'Waiting for hearing date',
          BUTTON: null
        },
        GUARDIANADLITEM:{
          STATUS: 'Documents uploaded',
          BUTTON: null
        },
        ATTORNEY: {
          STATUS: 'Waiting for hearing date',
          BUTTON: null
        }

      },
      THREEFOUR: {

        CLERK: {
          STATUS: 'Assign guardians',
          BUTTON: 'Assign'
        },
        PETITIONER: {
          STATUS: 'Guardian being appointed',
          BUTTON: null
        },
        GUARDIAN: {
          STATUS: 'Guardian being appointed',
          BUTTON: null
        },
        JUDGE: {
          STATUS: 'Assign guardians',
          BUTTON: 'Assign'
        },
        HEIR: {
          STATUS: 'Guardian being appointed',
          BUTTON: null
        },
        ATTORNEY: {
          STATUS: 'Guardian being appointed',
          BUTTON: null
        }

      },
      TWOEIGHT: {

        CLERK: {
          STATUS: 'Form review',
          BUTTON: 'Review'
        },
        PETITIONER: {
          STATUS: 'Submitted to court',
          BUTTON: null
        },
        GUARDIAN: {
          STATUS: 'Submitted to court',
          BUTTON: 'Upload'
        },
        HEIR: {
          STATUS: 'Submitted to court',
          BUTTON: null
        },
        ATTORNEY: {
          STATUS: 'Submitted to court',
          BUTTON: null
        }

      },
      SEVENONE: {

        CLERK: {
          STATUS: 'Form review',
          BUTTON: 'Review'
        },
        PETITIONER: {
          STATUS: 'Submitted to court',
          BUTTON: null
        },
        GUARDIAN: {
          STATUS: 'Submitted to court',
          BUTTON: null
        },
        HEIR: {
          STATUS: 'Submitted to court',
          BUTTON: null
        },
        ATTORNEY: {
          STATUS: 'Submitted to court',
          BUTTON: null
        }

      },
      THREEFIVE: {

        CLERK: {
          STATUS: 'Review uploaded bond',
          BUTTON: 'Review bond'
        },
        PETITIONER: {
          STATUS: 'Submitted to court',
          BUTTON: null
        },
        GUARDIAN: {
          STATUS: 'Submitted to court',
          BUTTON: null
        },
        HEIR: {
          STATUS: 'Submitted to court',
          BUTTON: null
        },
        ATTORNEY: {
          STATUS: 'Submitted to court',
          BUTTON: null
        }

      }

    },
    FILED_FOR_JUDGE: {

      TWOTHREE: {

        CLERK: {
          STATUS: 'Appoint guardian ad litem',
          BUTTON: 'Assign'
        },
        PETITIONER: {
          STATUS: 'Waiting for case number',
          BUTTON: null
        },
        GUARDIAN: {
          STATUS: 'Waiting for case number',
          BUTTON: null
        },
        HEIR: {
          STATUS: 'Waiting for case number',
          BUTTON: null
        },
        ATTORNEY: {
          STATUS: 'Waiting for case number',
          BUTTON: null
        }

      },
      TWOFOUR: {

        CLERK: {
          STATUS: 'Form review',
          BUTTON: 'Review'
        },
        PETITIONER: {
          STATUS: 'Submitted to court',
          BUTTON: null
        },
        GUARDIAN: {
          STATUS: 'Submitted to court',
          BUTTON: null
        },
        HEIR: {
          STATUS: 'Submitted to court',
          BUTTON: null
        },
        ATTORNEY: {
          STATUS: 'Submitted to court',
          BUTTON: null
        }

      },
      THREEFOUR: {

        CLERK: {
          STATUS: 'Form review',
          BUTTON: 'Review'
        },
        PETITIONER: {
          STATUS: 'Submitted to court',
          BUTTON: null
        },
        GUARDIAN: {
          STATUS: 'Submitted to court',
          BUTTON: null
        },
        HEIR: {
          STATUS: 'Submitted to court',
          BUTTON: null
        },
        ATTORNEY: {
          STATUS: 'Submitted to court',
          BUTTON: null
        }

      },
      TWOEIGHT: {

        CLERK: {
          STATUS: 'Form review',
          BUTTON: 'Review'
        },
        PETITIONER: {
          STATUS: 'Submitted to court',
          BUTTON: null
        },
        GUARDIAN: {
          STATUS: 'Submitted to court',
          BUTTON: null
        },
        HEIR: {
          STATUS: 'Submitted to court',
          BUTTON: null
        },
        ATTORNEY: {
          STATUS: 'Submitted to court',
          BUTTON: null
        }

      },
      SEVENONE: {

        CLERK: {
          STATUS: 'Form review',
          BUTTON: 'Review'
        },
        PETITIONER: {
          STATUS: 'Submitted to court',
          BUTTON: null
        },
        GUARDIAN: {
          STATUS: 'Submitted to court',
          BUTTON: null
        },
        HEIR: {
          STATUS: 'Submitted to court',
          BUTTON: null
        },
        ATTORNEY: {
          STATUS: 'Submitted to court',
          BUTTON: null
        }

      }

    },
    APPROVED_BY_CLERK: {

      TWOTHREE: {

        CLERK: {
          STATUS: 'Submit bond',
          BUTTON: 'Upload'
        },
        PETITIONER: {
          STATUS: 'Upload bond',
          BUTTON: 'UPLOAD'
        },
        GUARDIAN: {
          STATUS: 'Upload bond',
          BUTTON: 'Upload'
        },
        HEIR: {
          STATUS: 'Waiting for guardian bond',
          BUTTON: null
        },
        ATTORNEY: {
          STATUS: 'Waiting for guardian bond',
          BUTTON: null
        }

      },
      TWOFOUR: {

        CLERK: {
          STATUS: 'Approved form',
          BUTTON: null
        },
        PETITIONER: {
          STATUS: 'Approved form',
          BUTTON: null
        },
        GUARDIAN: {
          STATUS: 'Approved form',
          BUTTON: null
        },
        HEIR: {
          STATUS: 'Approved form',
          BUTTON: null
        },
        ATTORNEY: {
          STATUS: 'Approved form',
          BUTTON: null
        }

      },
      THREEFOUR: {

        CLERK: {
          STATUS: 'Submit bond',
          BUTTON: 'Upload'
        },
        PETITIONER: {
          STATUS: 'Submit bond',
          BUTTON: 'Upload'
        },
        GUARDIAN: {
          STATUS: 'Submit bond',
          BUTTON: 'Upload'
        },
        HEIR: {
          STATUS: 'Waiting for guardian',
          BUTTON: null
        },
        ATTORNEY: {
          STATUS: 'Waiting for guardian',
          BUTTON: null
        }

      },
      TWOEIGHT: {

        CLERK: {
          STATUS: 'Approved form',
          BUTTON: null
        },
        PETITIONER: {
          STATUS: 'Approved form',
          BUTTON: null
        },
        GUARDIAN: {
          STATUS: 'Approved form',
          BUTTON: null
        },
        HEIR: {
          STATUS: 'Approved form',
          BUTTON: null
        },
        ATTORNEY: {
          STATUS: 'Approved form',
          BUTTON: null
        }

      },
      SEVENONE: {

        CLERK: {
          STATUS: 'Approved form',
          BUTTON: null
        },
        PETITIONER: {
          STATUS: 'Approved form',
          BUTTON: null
        },
        GUARDIAN: {
          STATUS: 'Approved form',
          BUTTON: null
        },
        HEIR: {
          STATUS: 'Approved form',
          BUTTON: null
        },
        ATTORNEY: {
          STATUS: 'Approved form',
          BUTTON: null
        }

      },
      THREEFIVE: {

        CLERK: {
          STATUS: 'Submit bond',
          BUTTON: 'Upload'
        },
        PETITIONER: {
          STATUS: 'Upload bond',
          BUTTON: 'UPLOAD'
        },
        GUARDIAN: {
          STATUS: 'Upload bond',
          BUTTON: 'Upload'
        },
        HEIR: {
          STATUS: 'Waiting for guardian bond',
          BUTTON: null
        },
        ATTORNEY: {
          STATUS: 'Waiting for guardian bond',
          BUTTON: null
        }

      }

    },
    APPROVED_BY_JUDGE: {

      TWOTHREE: {

        CLERK: {
          STATUS: 'Approved form',
          BUTTON: null
        },
        PETITIONER: {
          STATUS: 'Approved form',
          BUTTON: null
        },
        GUARDIAN: {
          STATUS: 'Approved form',
          BUTTON: null
        },
        HEIR: {
          STATUS: 'Approved form',
          BUTTON: null
        },
        ATTORNEY: {
          STATUS: 'Approved form',
          BUTTON: null
        }

      },
      TWOFOUR: {

        CLERK: {
          STATUS: 'Approved form',
          BUTTON: null
        },
        PETITIONER: {
          STATUS: 'Approved form',
          BUTTON: null
        },
        GUARDIAN: {
          STATUS: 'Approved form',
          BUTTON: null
        },
        HEIR: {
          STATUS: 'Approved form',
          BUTTON: null
        },
        ATTORNEY: {
          STATUS: 'Approved form',
          BUTTON: null
        }

      },
      THREEFOUR: {

        CLERK: {
          STATUS: 'Approved form',
          BUTTON: null
        },
        PETITIONER: {
          STATUS: 'Approved form',
          BUTTON: null
        },
        GUARDIAN: {
          STATUS: 'Approved form',
          BUTTON: null
        },
        HEIR: {
          STATUS: 'Approved form',
          BUTTON: null
        },
        ATTORNEY: {
          STATUS: 'Approved form',
          BUTTON: null
        }

      },
      TWOEIGHT: {

        CLERK: {
          STATUS: 'Approved form',
          BUTTON: null
        },
        PETITIONER: {
          STATUS: 'Approved form',
          BUTTON: null
        },
        GUARDIAN: {
          STATUS: 'Approved form',
          BUTTON: null
        },
        HEIR: {
          STATUS: 'Approved form',
          BUTTON: null
        },
        ATTORNEY: {
          STATUS: 'Approved form',
          BUTTON: null
        }

      },
      SEVENONE: {

        CLERK: {
          STATUS: 'Approved form',
          BUTTON: null
        },
        PETITIONER: {
          STATUS: 'Approved form',
          BUTTON: null
        },
        GUARDIAN: {
          STATUS: 'Approved form',
          BUTTON: null
        },
        HEIR: {
          STATUS: 'Approved form',
          BUTTON: null
        },
        ATTORNEY: {
          STATUS: 'Approved form',
          BUTTON: null
        }

      },
      THREEFIVE: {

        CLERK: {
          STATUS: 'Approved form',
          BUTTON: null
        },
        PETITIONER: {
          STATUS: 'Approved form',
          BUTTON: null
        },
        GUARDIAN: {
          STATUS: 'Approved form',
          BUTTON: null
        },
        HEIR: {
          STATUS: 'Approved form',
          BUTTON: null
        },
        ATTORNEY: {
          STATUS: 'Approved form',
          BUTTON: null
        }

      }

    },
    DENIED_BY_CLERK: {

      TWOTHREE: {

        CLERK: {
          STATUS: 'Form rejected',
          BUTTON: null
        },
        PETITIONER: {
          STATUS: 'Form rejected',
          BUTTON: 'Resubmit'
        },
        GUARDIAN: {
          STATUS: 'Form rejected',
          BUTTON: null
        },
        HEIR: {
          STATUS: 'Form rejected',
          BUTTON: null
        },
        ATTORNEY: {
          STATUS: 'Form rejected',
          BUTTON: null
        }

      },
      TWOFOUR: {

        CLERK: {
          STATUS: 'Form rejected',
          BUTTON: null
        },
        PETITIONER: {
          STATUS: 'Form rejected',
          BUTTON: 'Resubmit'
        },
        GUARDIAN: {
          STATUS: 'Form rejected',
          BUTTON: null
        },
        HEIR: {
          STATUS: 'Form rejected',
          BUTTON: null
        },
        ATTORNEY: {
          STATUS: 'Form rejected',
          BUTTON: null
        }

      },
      THREEFOUR: {

        CLERK: {
          STATUS: 'Form rejected',
          BUTTON: null
        },
        PETITIONER: {
          STATUS: 'Form rejected',
          BUTTON: 'Resubmit'
        },
        GUARDIAN: {
          STATUS: 'Form rejected',
          BUTTON: null
        },
        HEIR: {
          STATUS: 'Form rejected',
          BUTTON: null
        },
        ATTORNEY: {
          STATUS: 'Form rejected',
          BUTTON: null
        }

      },
      TWOEIGHT: {

        CLERK: {
          STATUS: 'Form rejected',
          BUTTON: null
        },
        PETITIONER: {
          STATUS: 'Form rejected',
          BUTTON: null
        },
        GUARDIAN: {
          STATUS: 'Form rejected',
          BUTTON: 'Resubmit'
        },
        HEIR: {
          STATUS: 'Form rejected',
          BUTTON: null
        },
        ATTORNEY: {
          STATUS: 'Form rejected',
          BUTTON: null
        }

      },
      SEVENONE: {

        CLERK: {
          STATUS: 'Form rejected',
          BUTTON: null
        },
        PETITIONER: {
          STATUS: 'Form rejected',
          BUTTON: null
        },
        GUARDIAN: {
          STATUS: 'Form rejected',
          BUTTON: 'Resubmit'
        },
        HEIR: {
          STATUS: 'Form rejected',
          BUTTON: null
        },
        ATTORNEY: {
          STATUS: 'Form rejected',
          BUTTON: null
        }

      },
      THREEFIVE: {

        CLERK: {
          STATUS: 'Denied',
          BUTTON: null
        },
        PETITIONER: {
          STATUS: 'Needs Reupload',
          BUTTON: null
        },
        GUARDIAN: {
          STATUS: 'Needs Reupload',
          BUTTON: 'Upload'
        },
        HEIR: {
          STATUS: 'Needs Reupload',
          BUTTON: null
        },
        ATTORNEY: {
          STATUS: 'Needs Reupload',
          BUTTON: null
        }

      }

    },
    DENIED_BY_JUDGE: {

      TWOTHREE: {

        CLERK: {
          STATUS: 'Case denied',
          BUTTON: null
        },
        PETITIONER: {
          STATUS: 'Case denied',
          BUTTON: null
        },
        GUARDIAN: {
          STATUS: 'Case denied',
          BUTTON: null
        },
        HEIR: {
          STATUS: 'Case denied',
          BUTTON: null
        },
        ATTORNEY: {
          STATUS: 'Case denied',
          BUTTON: null
        }

      },
      TWOFOUR: {

        CLERK: {
          STATUS: 'Form rejected',
          BUTTON: null
        },
        PETITIONER: {
          STATUS: 'Form rejected',
          BUTTON: 'Resubmit'
        },
        GUARDIAN: {
          STATUS: 'Form rejected',
          BUTTON: null
        },
        HEIR: {
          STATUS: 'Form rejected',
          BUTTON: null
        },
        ATTORNEY: {
          STATUS: 'Form rejected',
          BUTTON: null
        }

      },
      THREEFOUR: {

        CLERK: {
          STATUS: 'Form rejected',
          BUTTON: null
        },
        PETITIONER: {
          STATUS: 'Form rejected',
          BUTTON: 'Resubmit'
        },
        GUARDIAN: {
          STATUS: 'Form rejected',
          BUTTON: null
        },
        HEIR: {
          STATUS: 'Form rejected',
          BUTTON: null
        },
        ATTORNEY: {
          STATUS: 'Form rejected',
          BUTTON: null
        }

      },
      TWOEIGHT: {

        CLERK: {
          STATUS: 'Form rejected',
          BUTTON: null
        },
        PETITIONER: {
          STATUS: 'Form rejected',
          BUTTON: null
        },
        GUARDIAN: {
          STATUS: 'Form rejected',
          BUTTON: 'Resubmit'
        },
        HEIR: {
          STATUS: 'Form rejected',
          BUTTON: null
        },
        ATTORNEY: {
          STATUS: 'Form rejected',
          BUTTON: null
        }

      },
      SEVENONE: {

        CLERK: {
          STATUS: 'Form rejected',
          BUTTON: null
        },
        PETITIONER: {
          STATUS: 'Form rejected',
          BUTTON: null
        },
        GUARDIAN: {
          STATUS: 'Form rejected',
          BUTTON: 'Resubmit'
        },
        HEIR: {
          STATUS: 'Form rejected',
          BUTTON: null
        },
        ATTORNEY: {
          STATUS: 'Form rejected',
          BUTTON: null
        }

      }

    },
    NEEDS_UPLOAD_FROM_CLERK: {

      TWOTHREE: {

        CLERK: {
          STATUS: 'Upload form',
          BUTTON: 'Upload'
        },
        PETITIONER: {
          STATUS: 'Waiting on court',
          BUTTON: null
        },
        GUARDIAN: {
          STATUS: 'Waiting on court',
          BUTTON: null
        },
        HEIR: {
          STATUS: 'Waiting on court',
          BUTTON: null
        },
        ATTORNEY: {
          STATUS: 'Waiting on court',
          BUTTON: null
        }

      },
      TWOFOUR: {

        CLERK: {
          STATUS: 'Upload form',
          BUTTON: 'Upload'
        },
        PETITIONER: {
          STATUS: 'Waiting on court',
          BUTTON: null
        },
        GUARDIAN: {
          STATUS: 'Waiting on court',
          BUTTON: null
        },
        HEIR: {
          STATUS: 'Waiting on court',
          BUTTON: null
        },
        ATTORNEY: {
          STATUS: 'Waiting on court',
          BUTTON: null
        }

      },
      THREEFOUR: {

        CLERK: {
          STATUS: 'Upload form',
          BUTTON: 'Upload'
        },
        PETITIONER: {
          STATUS: 'Waiting on court',
          BUTTON: null
        },
        GUARDIAN: {
          STATUS: 'Waiting on court',
          BUTTON: null
        },
        HEIR: {
          STATUS: 'Waiting on court',
          BUTTON: null
        },
        ATTORNEY: {
          STATUS: 'Waiting on court',
          BUTTON: null
        }

      },
      TWOEIGHT: {

        CLERK: {
          STATUS: 'Upload form',
          BUTTON: 'Upload'
        },
        PETITIONER: {
          STATUS: 'Waiting on court',
          BUTTON: null
        },
        GUARDIAN: {
          STATUS: 'Waiting on court',
          BUTTON: null
        },
        HEIR: {
          STATUS: 'Waiting on court',
          BUTTON: null
        },
        ATTORNEY: {
          STATUS: 'Waiting on court',
          BUTTON: null
        }

      },
      SEVENONE: {

        CLERK: {
          STATUS: 'Upload form',
          BUTTON: 'Upload'
        },
        PETITIONER: {
          STATUS: 'Waiting on court',
          BUTTON: null
        },
        GUARDIAN: {
          STATUS: 'Waiting on court',
          BUTTON: null
        },
        HEIR: {
          STATUS: 'Waiting on court',
          BUTTON: null
        },
        ATTORNEY: {
          STATUS: 'Waiting on court',
          BUTTON: null
        }

      }

    },
    NEEDS_UPLOAD_FROM_JUDGE: {

      TWOTHREE: {

        CLERK: {
          STATUS: 'Upload form for judge',
          BUTTON: 'Upload'
        },
        PETITIONER: {
          STATUS: 'Waiting on court',
          BUTTON: null
        },
        GUARDIAN: {
          STATUS: 'Waiting on court',
          BUTTON: null
        },
        HEIR: {
          STATUS: 'Waiting on court',
          BUTTON: null
        },
        ATTORNEY: {
          STATUS: 'Waiting on court',
          BUTTON: null
        }

      },
      TWOFOUR: {

        CLERK: {
          STATUS: 'Upload form for judge',
          BUTTON: 'Upload'
        },
        PETITIONER: {
          STATUS: 'Waiting on court',
          BUTTON: null
        },
        GUARDIAN: {
          STATUS: 'Waiting on court',
          BUTTON: null
        },
        HEIR: {
          STATUS: 'Waiting on court',
          BUTTON: null
        },
        ATTORNEY: {
          STATUS: 'Waiting on court',
          BUTTON: null
        }

      },
      THREEFOUR: {

        CLERK: {
          STATUS: 'Upload form for judge',
          BUTTON: 'Upload'
        },
        PETITIONER: {
          STATUS: 'Waiting on court',
          BUTTON: null
        },
        GUARDIAN: {
          STATUS: 'Waiting on court',
          BUTTON: null
        },
        HEIR: {
          STATUS: 'Waiting on court',
          BUTTON: null
        },
        ATTORNEY: {
          STATUS: 'Waiting on court',
          BUTTON: null
        }

      },
      TWOEIGHT: {

        CLERK: {
          STATUS: 'Upload form for judge',
          BUTTON: 'Upload'
        },
        PETITIONER: {
          STATUS: 'Waiting on court',
          BUTTON: null
        },
        GUARDIAN: {
          STATUS: 'Waiting on court',
          BUTTON: null
        },
        HEIR: {
          STATUS: 'Waiting on court',
          BUTTON: null
        },
        ATTORNEY: {
          STATUS: 'Waiting on court',
          BUTTON: null
        }

      },
      SEVENONE: {

        CLERK: {
          STATUS: 'Upload form for judge',
          BUTTON: 'Upload'
        },
        PETITIONER: {
          STATUS: 'Waiting on court',
          BUTTON: null
        },
        GUARDIAN: {
          STATUS: 'Waiting on court',
          BUTTON: null
        },
        HEIR: {
          STATUS: 'Waiting on court',
          BUTTON: null
        },
        ATTORNEY: {
          STATUS: 'Waiting on court',
          BUTTON: null
        }

      }

    },
    NEEDS_UPLOAD_FROM_PETITIONER: {

      TWOTHREE: {

        CLERK: {
          STATUS: 'Needs upload from petitioner',
          BUTTON: null
        },
        PETITIONER: {
          STATUS: 'Upload form',
          BUTTON: 'Upload'
        },
        GUARDIAN: {
          STATUS: 'How are you even seeing this? Contact support',
          BUTTON: null
        },
        HEIR: {
          STATUS: 'Needs upload from petitioner',
          BUTTON: null
        },
        GUARDIANADLITEM: {
          STATUS: 'Upload the Report submission and Fees Invoice',
          BUTTON: 'Upload'
        },
        ATTORNEY: {
          STATUS: 'Upload form',
          BUTTON: 'Upload'
        }

      },
      TWOFOUR: {

        CLERK: {
          STATUS: 'Needs upload from petitioner',
          BUTTON: null
        },
        PETITIONER: {
          STATUS: 'Upload form',
          BUTTON: 'Upload'
        },
        GUARDIAN: {
          STATUS: 'How are you even seeing this? Contact support',
          BUTTON: null
        },
        HEIR: {
          STATUS: 'Needs upload from petitioner',
          BUTTON: null
        },
        ATTORNEY: {
          STATUS: 'Needs upload from petitioner',
          BUTTON: null
        }

      },
      THREEFOUR: {

        CLERK: {
          STATUS: 'Needs upload from petitioner',
          BUTTON: null
        },
        PETITIONER: {
          STATUS: 'Upload form',
          BUTTON: 'Upload'
        },
        GUARDIAN: {
          STATUS: 'How are you even seeing this? Contact support',
          BUTTON: null
        },
        HEIR: {
          STATUS: 'Needs upload from petitioner',
          BUTTON: null
        },
        ATTORNEY: {
          STATUS: 'Needs upload from petitioner',
          BUTTON: null
        }

      },
      TWOEIGHT: {

        CLERK: {
          STATUS: 'Needs upload from petitioner',
          BUTTON: null
        },
        PETITIONER: {
          STATUS: 'Upload form',
          BUTTON: 'Upload'
        },
        GUARDIAN: {
          STATUS: 'How are you even seeing this? Contact support',
          BUTTON: null
        },
        HEIR: {
          STATUS: 'Needs upload from petitioner',
          BUTTON: null
        },
        ATTORNEY: {
          STATUS: 'Needs upload from petitioner',
          BUTTON: null
        }

      },
      SEVENONE: {

        CLERK: {
          STATUS: 'Needs upload from petitioner',
          BUTTON: null
        },
        PETITIONER: {
          STATUS: 'Upload form',
          BUTTON: 'Upload'
        },
        GUARDIAN: {
          STATUS: 'How are you even seeing this? Contact support',
          BUTTON: null
        },
        HEIR: {
          STATUS: 'Needs upload from petitioner',
          BUTTON: null
        },
        ATTORNEY: {
          STATUS: 'Needs upload from petitioner',
          BUTTON: null
        }

      }

    },
    NEEDS_UPLOAD_FROM_GUARDIAN: {

      TWOTHREE: {

        CLERK: {
          STATUS: 'Needs upload from guardian',
          BUTTON: null
        },
        PETITIONER: {
          STATUS: 'Needs upload from guardian',
          BUTTON: null
        },
        GUARDIAN: {
          STATUS: 'Upload needed',
          BUTTON: 'Download and Upload'
        },
        HEIR: {
          STATUS: 'Needs upload from guardian',
          BUTTON: null
        },
        ATTORNEY: {
          STATUS: 'Needs upload from guardian',
          BUTTON: null
        }

      },
      TWOFOUR: {

        CLERK: {
          STATUS: 'Needs upload from guardian',
          BUTTON: null
        },
        PETITIONER: {
          STATUS: 'Needs upload from guardian',
          BUTTON: null
        },
        GUARDIAN: {
          STATUS: 'Upload needed',
          BUTTON: 'Download and Upload'
        },
        HEIR: {
          STATUS: 'Needs upload from guardian',
          BUTTON: null
        },
        ATTORNEY: {
          STATUS: 'Needs upload from guardian',
          BUTTON: null
        }

      },
      THREEFOUR: {

        CLERK: {
          STATUS: 'Needs upload from guardian',
          BUTTON: null
        },
        PETITIONER: {
          STATUS: 'Needs upload from guardian',
          BUTTON: null
        },
        GUARDIAN: {
          STATUS: 'Upload needed',
          BUTTON: 'Download and Upload'
        },
        HEIR: {
          STATUS: 'Needs upload from guardian',
          BUTTON: null
        },
        ATTORNEY: {
          STATUS: 'Needs upload from guardian',
          BUTTON: null
        }

      },
      TWOEIGHT: {

        CLERK: {
          STATUS: 'Needs upload from guardian',
          BUTTON: null
        },
        PETITIONER: {
          STATUS: 'Needs upload from guardian',
          BUTTON: null
        },
        GUARDIAN: {
          STATUS: 'Upload needed',
          BUTTON: 'Download and Upload'
        },
        HEIR: {
          STATUS: 'Needs upload from guardian',
          BUTTON: null
        },
        ATTORNEY: {
          STATUS: 'Needs upload from guardian',
          BUTTON: null
        }

      },
      SEVENONE: {

        CLERK: {
          STATUS: 'Needs upload from guardian',
          BUTTON: null
        },
        PETITIONER: {
          STATUS: 'Needs upload from guardian',
          BUTTON: null
        },
        GUARDIAN: {
          STATUS: 'Upload needed',
          BUTTON: 'Download and Upload'
        },
        HEIR: {
          STATUS: 'Needs upload from guardian',
          BUTTON: null
        },
        ATTORNEY: {
          STATUS: 'Needs upload from guardian',
          BUTTON: null
        }

      },
      THREEFIVE: {

        CLERK: {
          STATUS: 'Needs upload from guardian',
          BUTTON: null
        },
        PETITIONER: {
          STATUS: 'Needs upload from guardian',
          BUTTON: null
        },
        GUARDIAN: {
          STATUS: 'Upload needed',
          BUTTON: 'Download and Upload'
        },
        HEIR: {
          STATUS: 'Needs upload from guardian',
          BUTTON: null
        },
        ATTORNEY: {
          STATUS: 'Needs upload from guardian',
          BUTTON: null
        }

      },
      NINETWO: {

        CLERK: {
          STATUS: 'Needs upload from guardian',
          BUTTON: null
        },
        PETITIONER: {
          STATUS: 'Upload needed',
          BUTTON: 'Download and Upload'
        },
        GUARDIAN: {
          STATUS: 'Upload needed',
          BUTTON: 'Download and Upload'
        },
        HEIR: {
          STATUS: 'Needs upload from guardian',
          BUTTON: null
        },
        ATTORNEY: {
          STATUS: 'Upload needed',
          BUTTON: 'Download and Upload'
        }

      }

    },
    UPLOAD_DENIED_BY_CLERK: {

      TWOTHREE: {

        CLERK: {
          STATUS: 'Upload rejected',
          BUTTON: null
        },
        PETITIONER: {
          STATUS: 'Upload rejected',
          BUTTON: 'Resubmit'
        },
        GUARDIAN: {
          STATUS: 'Upload rejected',
          BUTTON: null
        },
        HEIR: {
          STATUS: 'Upload rejected',
          BUTTON: null
        },
        ATTORNEY: {
          STATUS: 'Upload rejected',
          BUTTON: 'Resubmit'
        }

      },
      TWOFOUR: {

        CLERK: {
          STATUS: 'Upload rejected',
          BUTTON: null
        },
        PETITIONER: {
          STATUS: 'Upload rejected',
          BUTTON: 'Resubmit'
        },
        GUARDIAN: {
          STATUS: 'Upload rejected',
          BUTTON: null
        },
        HEIR: {
          STATUS: 'Upload rejected',
          BUTTON: null
        },
        ATTORNEY: {
          STATUS: 'Upload rejected',
          BUTTON: null
        }

      },
      THREEFOUR: {

        CLERK: {
          STATUS: 'Upload rejected',
          BUTTON: null
        },
        PETITIONER: {
          STATUS: 'Upload rejected',
          BUTTON: null
        },
        GUARDIAN: {
          STATUS: 'Upload rejected',
          BUTTON: 'Resubmit'
        },
        HEIR: {
          STATUS: 'Upload rejected',
          BUTTON: null
        },
        ATTORNEY: {
          STATUS: 'Upload rejected',
          BUTTON: null
        }

      },
      TWOEIGHT: {

        CLERK: {
          STATUS: 'Upload rejected',
          BUTTON: null
        },
        PETITIONER: {
          STATUS: 'Upload rejected',
          BUTTON: null
        },
        GUARDIAN: {
          STATUS: 'Upload rejected',
          BUTTON: 'Resubmit'
        },
        HEIR: {
          STATUS: 'Upload rejected',
          BUTTON: null
        },
        ATTORNEY: {
          STATUS: 'Upload rejected',
          BUTTON: null
        }

      },
      SEVENONE: {

        CLERK: {
          STATUS: 'Upload rejected',
          BUTTON: null
        },
        PETITIONER: {
          STATUS: 'Upload rejected',
          BUTTON: null
        },
        GUARDIAN: {
          STATUS: 'Upload rejected',
          BUTTON: 'Resubmit'
        },
        HEIR: {
          STATUS: 'Upload rejected',
          BUTTON: null
        },
        ATTORNEY: {
          STATUS: 'Upload rejected',
          BUTTON: null
        }

      }

    },
    UPLOAD_DENIED_BY_JUDGE: {

      TWOTHREE: {

        CLERK: {
          STATUS: 'Upload rejected',
          BUTTON: null
        },
        PETITIONER: {
          STATUS: 'Upload rejected',
          BUTTON: 'Resubmit'
        },
        GUARDIAN: {
          STATUS: 'Upload rejected',
          BUTTON: null
        },
        HEIR: {
          STATUS: 'Upload rejected',
          BUTTON: null
        },
        ATTORNEY: {
          STATUS: 'Upload rejected',
          BUTTON: 'Resubmit'
        }

      },
      TWOFOUR: {

        CLERK: {
          STATUS: 'Upload rejected',
          BUTTON: null
        },
        PETITIONER: {
          STATUS: 'Upload rejected',
          BUTTON: 'Resubmit'
        },
        GUARDIAN: {
          STATUS: 'Upload rejected',
          BUTTON: null
        },
        HEIR: {
          STATUS: 'Upload rejected',
          BUTTON: null
        },
        ATTORNEY: {
          STATUS: 'Upload rejected',
          BUTTON: null
        }

      },
      THREEFOUR: {

        CLERK: {
          STATUS: 'Upload rejected',
          BUTTON: null
        },
        PETITIONER: {
          STATUS: 'Upload rejected',
          BUTTON: null
        },
        GUARDIAN: {
          STATUS: 'Upload rejected',
          BUTTON: 'Resubmit'
        },
        HEIR: {
          STATUS: 'Upload rejected',
          BUTTON: null
        },
        ATTORNEY: {
          STATUS: 'Upload rejected',
          BUTTON: null
        }

      },
      TWOEIGHT: {

        CLERK: {
          STATUS: 'Upload rejected',
          BUTTON: null
        },
        PETITIONER: {
          STATUS: 'Upload rejected',
          BUTTON: null
        },
        GUARDIAN: {
          STATUS: 'Upload rejected',
          BUTTON: 'Resubmit'
        },
        HEIR: {
          STATUS: 'Upload rejected',
          BUTTON: null
        },
        ATTORNEY: {
          STATUS: 'Upload rejected',
          BUTTON: null
        }

      },
      SEVENONE: {

        CLERK: {
          STATUS: 'Upload rejected',
          BUTTON: null
        },
        PETITIONER: {
          STATUS: 'Upload rejected',
          BUTTON: null
        },
        GUARDIAN: {
          STATUS: 'Upload rejected',
          BUTTON: 'Resubmit'
        },
        HEIR: {
          STATUS: 'Upload rejected',
          BUTTON: null
        },
        ATTORNEY: {
          STATUS: 'Upload rejected',
          BUTTON: null
        }

      },
      THREEFIVE: {

        CLERK: {
          STATUS: 'Upload rejected',
          BUTTON: null
        },
        PETITIONER: {
          STATUS: 'Upload rejected',
          BUTTON: 'Resubmit'
        },
        GUARDIAN: {
          STATUS: 'Upload rejected',
          BUTTON: 'Resubmit'
        },
        HEIR: {
          STATUS: 'Upload rejected',
          BUTTON: null
        },
        ATTORNEY: {
          STATUS: 'Upload rejected',
          BUTTON: null
        }

      },
      NINETWO: {

        CLERK: {
          STATUS: 'Upload rejected',
          BUTTON: null
        },
        PETITIONER: {
          STATUS: 'Upload rejected',
          BUTTON: 'Resubmit'
        },
        GUARDIAN: {
          STATUS: 'Upload rejected',
          BUTTON: null
        },
        HEIR: {
          STATUS: 'Upload rejected',
          BUTTON: null
        },
        ATTORNEY: {
          STATUS: 'Upload rejected',
          BUTTON: 'Resubmit'
        }

      }

    },
    UPLOAD_APPROVED_BY_CLERK: {

      TWOTHREE: {

        CLERK: {
          STATUS: 'Approved form',
          BUTTON: null
        },
        PETITIONER: {
          STATUS: 'Approved form',
          BUTTON: null
        },
        GUARDIAN: {
          STATUS: 'Approved form',
          BUTTON: null
        },
        HEIR: {
          STATUS: 'Approved form',
          BUTTON: null
        },
        ATTORNEY: {
          STATUS: 'Approved form',
          BUTTON: null
        }

      },
      TWOFOUR: {

        CLERK: {
          STATUS: 'Approved form',
          BUTTON: null
        },
        PETITIONER: {
          STATUS: 'Approved form',
          BUTTON: null
        },
        GUARDIAN: {
          STATUS: 'Approved form',
          BUTTON: null
        },
        HEIR: {
          STATUS: 'Approved form',
          BUTTON: null
        },
        ATTORNEY: {
          STATUS: 'Approved form',
          BUTTON: null
        }

      },
      THREEFOUR: {

        CLERK: {
          STATUS: 'Approved form',
          BUTTON: null
        },
        PETITIONER: {
          STATUS: 'Approved form',
          BUTTON: null
        },
        GUARDIAN: {
          STATUS: 'Approved form',
          BUTTON: null
        },
        HEIR: {
          STATUS: 'Approved form',
          BUTTON: null
        },
        ATTORNEY: {
          STATUS: 'Approved form',
          BUTTON: null
        }

      },
      TWOEIGHT: {

        CLERK: {
          STATUS: 'Approved form',
          BUTTON: null
        },
        PETITIONER: {
          STATUS: 'Approved form',
          BUTTON: null
        },
        GUARDIAN: {
          STATUS: 'Approved form',
          BUTTON: null
        },
        HEIR: {
          STATUS: 'Approved form',
          BUTTON: null
        },
        ATTORNEY: {
          STATUS: 'Approved form',
          BUTTON: null
        }

      },
      SEVENONE: {

        CLERK: {
          STATUS: 'Approved form',
          BUTTON: null
        },
        PETITIONER: {
          STATUS: 'Approved form',
          BUTTON: null
        },
        GUARDIAN: {
          STATUS: 'Approved form',
          BUTTON: null
        },
        HEIR: {
          STATUS: 'Approved form',
          BUTTON: null
        },
        ATTORNEY: {
          STATUS: 'Approved form',
          BUTTON: null
        }

      },
      THREEFIVE: {

        CLERK: {
          STATUS: 'Approved form',
          BUTTON: null
        },
        PETITIONER: {
          STATUS: 'Approved form',
          BUTTON: null
        },
        GUARDIAN: {
          STATUS: 'Approved form',
          BUTTON: null
        },
        HEIR: {
          STATUS: 'Approved form',
          BUTTON: null
        },
        ATTORNEY: {
          STATUS: 'Approved form',
          BUTTON: null
        }

      },
      NINETWO: {

        CLERK: {
          STATUS: 'Approved form',
          BUTTON: null
        },
        PETITIONER: {
          STATUS: 'Approved form',
          BUTTON: null
        },
        GUARDIAN: {
          STATUS: 'Approved form',
          BUTTON: null
        },
        HEIR: {
          STATUS: 'Approved form',
          BUTTON: null
        },
        ATTORNEY: {
          STATUS: 'Approved form',
          BUTTON: null
        }

      }

    },
    UPLOAD_APPROVED_BY_JUDGE: {

      TWOTHREE: {

        CLERK: {
          STATUS: 'Approved form',
          BUTTON: null
        },
        PETITIONER: {
          STATUS: 'Approved form',
          BUTTON: null
        },
        GUARDIAN: {
          STATUS: 'Approved form',
          BUTTON: null
        },
        HEIR: {
          STATUS: 'Approved form',
          BUTTON: null
        },
        ATTORNEY: {
          STATUS: 'Approved form',
          BUTTON: null
        }

      },
      TWOFOUR: {

        CLERK: {
          STATUS: 'Approved form',
          BUTTON: null
        },
        PETITIONER: {
          STATUS: 'Approved form',
          BUTTON: null
        },
        GUARDIAN: {
          STATUS: 'Approved form',
          BUTTON: null
        },
        HEIR: {
          STATUS: 'Approved form',
          BUTTON: null
        },
        ATTORNEY: {
          STATUS: 'Approved form',
          BUTTON: null
        }

      },
      THREEFOUR: {

        CLERK: {
          STATUS: 'Approved form',
          BUTTON: null
        },
        PETITIONER: {
          STATUS: 'Approved form',
          BUTTON: null
        },
        GUARDIAN: {
          STATUS: 'Approved form',
          BUTTON: null
        },
        HEIR: {
          STATUS: 'Approved form',
          BUTTON: null
        },
        ATTORNEY: {
          STATUS: 'Approved form',
          BUTTON: null
        }

      },
      TWOEIGHT: {

        CLERK: {
          STATUS: 'Approved form',
          BUTTON: null
        },
        PETITIONER: {
          STATUS: 'Approved form',
          BUTTON: null
        },
        GUARDIAN: {
          STATUS: 'Approved form',
          BUTTON: null
        },
        HEIR: {
          STATUS: 'Approved form',
          BUTTON: null
        },
        ATTORNEY: {
          STATUS: 'Approved form',
          BUTTON: null
        }

      },
      SEVENONE: {

        CLERK: {
          STATUS: 'Approved form',
          BUTTON: null
        },
        PETITIONER: {
          STATUS: 'Approved form',
          BUTTON: null
        },
        GUARDIAN: {
          STATUS: 'Approved form',
          BUTTON: null
        },
        HEIR: {
          STATUS: 'Approved form',
          BUTTON: null
        },
        ATTORNEY: {
          STATUS: 'Approved form',
          BUTTON: null
        }

      }

    },
    PAYMENT_REQUIRED: {
      TWOTHREE: {
        CLERK: {
          STATUS: 'Pay in person',
          BUTTON: 'Pay'
        },
        PETITIONER: {
          STATUS: 'Upload submitted to court',
          BUTTON: null
        },
        GUARDIAN: {
          STATUS: 'Upload submitted to court',
          BUTTON: null
        },
        HEIR: {
          STATUS: 'Upload submitted to court',
          BUTTON: null
        },
        ATTORNEY: {
          STATUS: 'Upload submitted to court',
          BUTTON: null
        }
      }
    },
    UPLOAD_FILED_FOR_CLERK: {

      TWOTHREE: {

        CLERK: {
          STATUS: 'Upload to review',
          BUTTON: 'Review'
        },
        PETITIONER: {
          STATUS: 'Upload submitted to court',
          BUTTON: null
        },
        GUARDIAN: {
          STATUS: 'Upload submitted to court',
          BUTTON: null
        },
        HEIR: {
          STATUS: 'Upload submitted to court',
          BUTTON: null
        },
        ATTORNEY: {
          STATUS: 'Upload submitted to court',
          BUTTON: null
        }

      },
      TWOFOUR: {

        CLERK: {
          STATUS: 'Hearing date set',
          BUTTON: 'Judgement'
        },
        PETITIONER: {
          STATUS: 'Waiting for judgement',
          BUTTON: null
        },
        GUARDIAN: {
          STATUS: 'Waiting for judgement',
          BUTTON: null
        },
        JUDGE: {
          STATUS: 'Hearing date set',
          BUTTON: 'Judgement'
        },
        HEIR: {
          STATUS: 'Waiting for judgement',
          BUTTON: null
        },
        GUARDIANADLITEM: {
          STATUS: 'Waiting for judgement',
          BUTTON: null
        },
        ATTORNEY: {
          STATUS: 'Waiting for judgement',
          BUTTON: null
        }

      },
      THREEFOUR: {

        CLERK: {
          STATUS: 'Upload to review',
          BUTTON: 'Review'
        },
        PETITIONER: {
          STATUS: 'Upload submitted to court',
          BUTTON: null
        },
        GUARDIAN: {
          STATUS: 'Upload submitted to court',
          BUTTON: null
        },
        HEIR: {
          STATUS: 'Upload submitted to court',
          BUTTON: null
        },
        ATTORNEY: {
          STATUS: 'Upload submitted to court',
          BUTTON: null
        }

      },
      TWOEIGHT: {

        CLERK: {
          STATUS: 'Upload to review',
          BUTTON: 'Review'
        },
        PETITIONER: {
          STATUS: 'Upload submitted to court',
          BUTTON: null
        },
        GUARDIAN: {
          STATUS: 'Upload submitted to court',
          BUTTON: null
        },
        HEIR: {
          STATUS: 'Upload submitted to court',
          BUTTON: null
        },
        ATTORNEY: {
          STATUS: 'Upload submitted to court',
          BUTTON: null
        }

      },
      SEVENONE: {

        CLERK: {
          STATUS: 'Upload to review',
          BUTTON: 'Review'
        },
        PETITIONER: {
          STATUS: 'Upload submitted to court',
          BUTTON: null
        },
        GUARDIAN: {
          STATUS: 'Upload submitted to court',
          BUTTON: null
        },
        HEIR: {
          STATUS: 'Upload submitted to court',
          BUTTON: null
        },
        ATTORNEY: {
          STATUS: 'Upload submitted to court',
          BUTTON: null
        }

      },
      THREEFIVE: {

        CLERK: {
          STATUS: 'Upload to review',
          BUTTON: 'Review'
        },
        PETITIONER: {
          STATUS: 'Upload submitted to court',
          BUTTON: null
        },
        GUARDIAN: {
          STATUS: 'Upload submitted to court',
          BUTTON: null
        },
        HEIR: {
          STATUS: 'Upload submitted to court',
          BUTTON: null
        },
        ATTORNEY: {
          STATUS: 'Upload submitted to court',
          BUTTON: null
        }

      },
      NINETWO: {

        CLERK: {
          STATUS: 'Upload to review',
          BUTTON: 'Review'
        },
        PETITIONER: {
          STATUS: 'Upload submitted to court',
          BUTTON: null
        },
        GUARDIAN: {
          STATUS: 'Upload submitted to court',
          BUTTON: null
        },
        HEIR: {
          STATUS: 'Upload submitted to court',
          BUTTON: null
        },
        ATTORNEY: {
          STATUS: 'Upload submitted to court',
          BUTTON: null
        }

      }

    },
    UPLOAD_FILED_FOR_JUDGE: {

      TWOTHREE: {

        CLERK: {
          STATUS: 'Upload to review',
          BUTTON: 'Review'
        },
        PETITIONER: {
          STATUS: 'Upload submitted to court',
          BUTTON: null
        },
        GUARDIAN: {
          STATUS: 'Upload submitted to court',
          BUTTON: null
        },
        HEIR: {
          STATUS: 'Upload submitted to court',
          BUTTON: null
        },
        ATTORNEY: {
          STATUS: 'Upload submitted to court',
          BUTTON: null
        }

      },
      TWOFOUR: {

        CLERK: {
          STATUS: 'Upload to review',
          BUTTON: 'Review'
        },
        PETITIONER: {
          STATUS: 'Upload submitted to court',
          BUTTON: null
        },
        GUARDIAN: {
          STATUS: 'Upload submitted to court',
          BUTTON: null
        },
        HEIR: {
          STATUS: 'Upload submitted to court',
          BUTTON: null
        },
        ATTORNEY: {
          STATUS: 'Upload submitted to court',
          BUTTON: null
        }

      },
      THREEFOUR: {

        CLERK: {
          STATUS: 'Upload to review',
          BUTTON: 'Review'
        },
        PETITIONER: {
          STATUS: 'Upload submitted to court',
          BUTTON: null
        },
        GUARDIAN: {
          STATUS: 'Upload submitted to court',
          BUTTON: null
        },
        HEIR: {
          STATUS: 'Upload submitted to court',
          BUTTON: null
        },
        ATTORNEY: {
          STATUS: 'Upload submitted to court',
          BUTTON: null
        }

      },
      TWOEIGHT: {

        CLERK: {
          STATUS: 'Upload to review',
          BUTTON: 'Review'
        },
        PETITIONER: {
          STATUS: 'Upload submitted to court',
          BUTTON: null
        },
        GUARDIAN: {
          STATUS: 'Upload submitted to court',
          BUTTON: null
        },
        HEIR: {
          STATUS: 'Upload submitted to court',
          BUTTON: null
        },
        ATTORNEY: {
          STATUS: 'Upload submitted to court',
          BUTTON: null
        }

      },
      SEVENONE: {

        CLERK: {
          STATUS: 'Upload to review',
          BUTTON: 'Review'
        },
        PETITIONER: {
          STATUS: 'Upload submitted to court',
          BUTTON: null
        },
        GUARDIAN: {
          STATUS: 'Upload submitted to court',
          BUTTON: null
        },
        HEIR: {
          STATUS: 'Upload submitted to court',
          BUTTON: null
        },
        ATTORNEY: {
          STATUS: 'Upload submitted to court',
          BUTTON: null
        }

      }

    },
    WAITING_FOR_GA: {

      TWOTHREE: {

        GUARDIANADLITEM: {
          STATUS: 'Waiting for Guardian Ad Litem',
          BUTTON: 'Accept / Deny'
        },
        CLERK: {
          STATUS: 'Waiting for Guardian Ad Litem',
          BUTTON: 'Accept / Deny'
        },
        PETITIONER: {
          STATUS: 'Waiting for Guardian Ad Litem',
          BUTTON: null
        },
        ATTORNEY: {
          STATUS: 'Waiting for Guardian Ad Litem',
          BUTTON: null
        },
        HEIR: {
          STATUS: 'Waiting for Guardian Ad Litem',
          BUTTON: null
        }

      },
      TWOFOUR: {

        GUARDIANADLITEM: {
          STATUS: 'Waiting for Guardian Ad Litem',
          BUTTON: 'Accept / Deny'
        },
        CLERK: {
          STATUS: 'Waiting for Guardian Ad Litem',
          BUTTON: 'Accept / Deny'
        },
        PETITIONER: {
          STATUS: 'Waiting for Guardian Ad Litem',
          BUTTON: null
        },
        ATTORNEY: {
          STATUS: 'Waiting for Guardian Ad Litem',
          BUTTON: null
        },
        HEIR: {
          STATUS: 'Waiting for Guardian Ad Litem',
          BUTTON: null
        }


      },
      THREEFOUR: {

        GUARDIANADLITEM: {
          STATUS: 'Waiting for Guardian Ad Litem',
          BUTTON: 'Accept / Deny'
        },
        CLERK: {
          STATUS: 'Waiting for Guardian Ad Litem',
          BUTTON: 'Accept / Deny'
        },
        PETITIONER: {
          STATUS: 'Waiting for Guardian Ad Litem',
          BUTTON: null
        },
        ATTORNEY: {
          STATUS: 'Waiting for Guardian Ad Litem',
          BUTTON: null
        },
        HEIR: {
          STATUS: 'Waiting for Guardian Ad Litem',
          BUTTON: null
        }


      },
      TWOEIGHT: {

        GUARDIANADLITEM: {
          STATUS: 'Waiting for Guardian Ad Litem',
          BUTTON: 'Accept / Deny'
        },
        CLERK: {
          STATUS: 'Waiting for Guardian Ad Litem',
          BUTTON: 'Accept / Deny'
        },
        PETITIONER: {
          STATUS: 'Waiting for Guardian Ad Litem',
          BUTTON: null
        },
        HEIR: {
          STATUS: 'Waiting for Guardian Ad Litem',
          BUTTON: null
        },
        ATTORNEY: {
          STATUS: 'Waiting for Guardian Ad Litem',
          BUTTON: null
        }


      },
      THREEFIVE: {

        GUARDIANADLITEM: {
          STATUS: 'Waiting for Guardian Ad Litem',
          BUTTON: 'Accept / Deny'
        },
        CLERK: {
          STATUS: 'Waiting for Guardian Ad Litem',
          BUTTON: 'Accept / Deny'
        },
        PETITIONER: {
          STATUS: 'Waiting for Guardian Ad Litem',
          BUTTON: null
        },
        HEIR: {
          STATUS: 'Waiting for Guardian Ad Litem',
          BUTTON: null
        },
        ATTORNEY: {
          STATUS: 'Waiting for Guardian Ad Litem',
          BUTTON: null
        }

      }

    },
    UPLOAD_DOCUMENT: {

      TWOTHREE: {

        GUARDIANADLITEM: {
          STATUS: 'Upload Appointment Form',
          BUTTON: 'Upload'
        },
        CLERK: {
          STATUS: 'Upload Appointment Form',
          BUTTON: 'Upload'
        }
      },
      TWOFOUR: {

        GUARDIANADLITEM: {
          STATUS: 'Upload Appointment Form',
          BUTTON: 'Upload'
        },
        CLERK: {
          STATUS: 'Upload Appointment Form',
          BUTTON: 'Upload'
        }


      },
      THREEFOUR: {

        GUARDIANADLITEM: {
          STATUS: 'Upload Appointment Form',
          BUTTON: 'Upload'
        },
        CLERK: {
          STATUS: 'Upload Appointment Form',
          BUTTON: 'Upload'
        }


      },
      TWOEIGHT: {

        GUARDIANADLITEM: {
          STATUS: 'Upload Appointment Form',
          BUTTON: 'Upload'
        },
        CLERK: {
          STATUS: 'Upload Appointment Form',
          BUTTON: 'Upload'
        }


      },
      THREEFIVE: {

        GUARDIANADLITEM: {
          STATUS: 'Upload Appointment Form',
          BUTTON: 'Upload'
        },
        CLERK: {
          STATUS: 'Upload Appointment Form',
          BUTTON: 'Upload'
        }

      }

    },
    APPOINT_GUARDIAN:{
      TWOTHREE: {
        CLERK: {
          STATUS: 'Assign guardians',
          BUTTON: 'Assign'
        },
        PETITIONER: {
          STATUS: 'Guardian being appointed',
          BUTTON: null
        },
        GUARDIAN: {
          STATUS: 'Guardian being appointed',
          BUTTON: null
        },
        JUDGE: {
          STATUS: 'Assign guardians',
          BUTTON: 'Assign'
        },
        HEIR: {
          STATUS: 'Guardian being appointed',
          BUTTON: null
        },
        ATTORNEY: {
          STATUS: 'Guardian being appointed',
          BUTTON: null
        }
      }
    },
    UPLOAD_REPORT_AND_FEES: {

      TWOTHREE: {

        GUARDIANADLITEM: {
          STATUS: 'Upload Report and Fees',
          BUTTON: 'Upload'
        },
        CLERK: {
          STATUS: 'Upload Report and Fees',
          BUTTON: 'Upload'
        }
      },
      TWOFOUR: {

        GUARDIANADLITEM: {
          STATUS: 'Upload Report and Fees',
          BUTTON: 'Upload'
        },
        CLERK: {
          STATUS: 'Upload Report and Fees',
          BUTTON: 'Upload'
        }

      },
      THREEFOUR: {

        GUARDIANADLITEM: {
          STATUS: 'Upload Report and Fees',
          BUTTON: 'Upload'
        },
        CLERK: {
          STATUS: 'Upload Report and Fees',
          BUTTON: 'Upload'
        }

      },
      TWOEIGHT: {

        GUARDIANADLITEM: {
          STATUS: 'Upload Report and Fees',
          BUTTON: 'Upload'
        },
        CLERK: {
          STATUS: 'Upload Report and Fees',
          BUTTON: 'Upload'
        }

      },
      THREEFIVE: {

        GUARDIANADLITEM: {
          STATUS: 'Upload Report and Fees',
          BUTTON: 'Upload'
        },
        CLERK: {
          STATUS: 'Upload Report and Fees',
          BUTTON: 'Upload'
        }
      }

    },
    BOND_UPLOADED: {

      TWOTHREE: {

        GUARDIAN: {
          STATUS: 'Upload Inventory form',
          BUTTON: 'Upload'
        },
        CLERK: {
          STATUS: 'Upload Inventory form',
          BUTTON: 'Upload'
        },
        PETITIONER: {
          STATUS: 'Upload Inventory form',
          BUTTON: 'Upload'
        },
        ATTORNEY: {
          STATUS: 'Upload Inventory form',
          BUTTON: 'Upload'
        },
        HEIR: {
          STATUS: 'Waiting for Inventory form from petitioner',
          BUTTON: null
        }

      },
      TWOFOUR: {

        GUARDIAN: {
          STATUS: 'Upload Inventory form',
          BUTTON: 'Upload'
        },
        CLERK: {
          STATUS: 'Upload Inventory form',
          BUTTON: 'Upload'
        },
        PETITIONER: {
          STATUS: 'Upload Inventory form',
          BUTTON: 'Upload'
        },
        ATTORNEY: {
          STATUS: 'Upload Inventory form',
          BUTTON: 'Upload'
        },
        HEIR: {
          STATUS: 'Waiting for Inventory form from petitioner',
          BUTTON: null
        }

      },
      THREEFOUR: {

        GUARDIAN: {
          STATUS: 'Upload Inventory form',
          BUTTON: 'Upload'
        },
        CLERK: {
          STATUS: 'Upload Inventory form',
          BUTTON: 'Upload'
        },
        PETITIONER: {
          STATUS: 'Upload Inventory form',
          BUTTON: 'Upload'
        },
        ATTORNEY: {
          STATUS: 'Upload Inventory form',
          BUTTON: 'Upload'
        },
        HEIR: {
          STATUS: 'Waiting for Inventory form from petitioner',
          BUTTON: null
        }

      },
      TWOEIGHT: {

        GUARDIAN: {
          STATUS: 'Upload Inventory form',
          BUTTON: 'Upload'
        },
        CLERK: {
          STATUS: 'Upload Inventory form',
          BUTTON: 'Upload'
        },
        PETITIONER: {
          STATUS: 'Upload Inventory form',
          BUTTON: 'Upload'
        },
        ATTORNEY: {
          STATUS: 'Upload Inventory form',
          BUTTON: 'Upload'
        },
        HEIR: {
          STATUS: 'Waiting for Inventory form from petitioner',
          BUTTON: null
        }

      },
      THREEFIVE: {

        GUARDIAN: {
          STATUS: 'Upload Inventory form',
          BUTTON: 'Upload'
        },
        CLERK: {
          STATUS: 'Upload Inventory form',
          BUTTON: 'Upload'
        },
        PETITIONER: {
          STATUS: 'Upload Inventory form',
          BUTTON: 'Upload'
        },
        ATTORNEY: {
          STATUS: 'Upload Inventory form',
          BUTTON: 'Upload'
        },
        HEIR: {
          STATUS: 'Waiting for Inventory form from petitioner',
          BUTTON: null
        }
      }

    },
    UPLOADED_INVENTORY: {

      TWOTHREE: {

        GUARDIAN: {
          STATUS: 'Inventory form uploaded',
          BUTTON: null
        },
        CLERK: {
          STATUS: 'Inventory form uploaded',
          BUTTON: 'Review'
        },
        PETITIONER: {
          STATUS: 'Inventory form uploaded',
          BUTTON: null
        },
        ATTORNEY: {
          STATUS: 'Inventory form uploaded',
          BUTTON: null
        },
        HEIR: {
          STATUS: 'Inventory form uploaded',
          BUTTON: null
        }

      },
      TWOFOUR: {

        GUARDIAN: {
          STATUS: 'Inventory form uploaded',
          BUTTON: null
        },
        CLERK: {
          STATUS: 'Bond uploaded',
          BUTTON: 'Review'
        },
        PETITIONER: {
          STATUS: 'Inventory form uploaded',
          BUTTON: null
        },
        HEIR: {
          STATUS: 'Inventory form uploaded',
          BUTTON: null
        },
        ATTORNEY: {
          STATUS: 'Inventory form uploaded',
          BUTTON: null
        }

      },
      THREEFOUR: {

        GUARDIAN: {
          STATUS: 'Inventory form uploaded',
          BUTTON: null
        },
        CLERK: {
          STATUS: 'Inventory form uploaded',
          BUTTON: 'Review'
        },
        PETITIONER: {
          STATUS: 'Inventory form uploaded',
          BUTTON: null
        },
        HEIR: {
          STATUS: 'Inventory form uploaded',
          BUTTON: null
        },
        ATTORNEY: {
          STATUS: 'Inventory form uploaded',
          BUTTON: null
        }

      },
      TWOEIGHT: {

        GUARDIAN: {
          STATUS: 'Inventory form uploaded',
          BUTTON: null
        },
        CLERK: {
          STATUS: 'Inventory form uploaded',
          BUTTON: 'Review'
        },
        PETITIONER: {
          STATUS: 'Inventory form uploaded',
          BUTTON: null
        },
        HEIR: {
          STATUS: 'Inventory form uploaded',
          BUTTON: null
        },
        ATTORNEY: {
          STATUS: 'Inventory form uploaded',
          BUTTON: null
        }

      },
      THREEFIVE: {

        GUARDIAN: {
          STATUS: 'Inventory form uploaded',
          BUTTON: null
        },
        CLERK: {
          STATUS: 'Inventory form uploaded',
          BUTTON: 'Review'
        },
        PETITIONER: {
          STATUS: 'Inventory form uploaded',
          BUTTON: null
        },
        HEIR: {
          STATUS: 'Inventory form uploaded',
          BUTTON: null
        },
        ATTORNEY: {
          STATUS: 'Inventory form uploaded',
          BUTTON: null
        }
      }

    },
    INVENTORY_AMOUNT_CHECK_PAID: {

      TWOTHREE: {

        GUARDIAN: {
          STATUS: 'Inventory Fees paid by check',
          BUTTON: null
        },
        CLERK: {
          STATUS: 'Pay in person',
          BUTTON: 'Pay'
        },
        PETITIONER: {
          STATUS: 'Inventory Fees paid by check',
          BUTTON: null
        },
        ATTORNEY: {
          STATUS: 'Inventory Fees paid by check',
          BUTTON: null
        },
        HEIR: {
          STATUS: 'Inventory Fees paid by check',
          BUTTON: null
        }

      },
      TWOFOUR: {

        GUARDIAN: {
          STATUS: 'Inventory Fees paid by check',
          BUTTON: null
        },
        CLERK: {
          STATUS: 'Inventory Fees paid by check',
          BUTTON: 'Amount Paid'
        },
        PETITIONER: {
          STATUS: 'Inventory Fees paid by check',
          BUTTON: null
        },
        HEIR: {
          STATUS: 'Inventory Fees paid by check',
          BUTTON: null
        },
        ATTORNEY: {
          STATUS: 'Inventory Fees paid by check',
          BUTTON: null
        }

      },
      THREEFOUR: {

        GUARDIAN: {
          STATUS: 'Inventory Fees paid by check',
          BUTTON: null
        },
        CLERK: {
          STATUS: 'Inventory Fees paid by check',
          BUTTON: 'Amount Paid'
        },
        PETITIONER: {
          STATUS: 'Inventory Fees paid by check',
          BUTTON: null
        },
        HEIR: {
          STATUS: 'Inventory Fees paid by check',
          BUTTON: null
        },
        ATTORNEY: {
          STATUS: 'Inventory Fees paid by check',
          BUTTON: null
        }

      },
      TWOEIGHT: {

        GUARDIAN: {
          STATUS: 'Inventory Fees paid by check',
          BUTTON: null
        },
        CLERK: {
          STATUS: 'Inventory Fees paid by check',
          BUTTON: 'Amount Paid'
        },
        PETITIONER: {
          STATUS: 'Inventory Fees paid by check',
          BUTTON: null
        },
        HEIR: {
          STATUS: 'Inventory Fees paid by check',
          BUTTON: null
        },
        ATTORNEY: {
          STATUS: 'Inventory Fees paid by check',
          BUTTON: null
        }

      },
      THREEFIVE: {

        GUARDIAN: {
          STATUS: 'Inventory Fees paid by check',
          BUTTON: null
        },
        CLERK: {
          STATUS: 'Inventory Fees paid by check',
          BUTTON: 'Amount Paid'
        },
        PETITIONER: {
          STATUS: 'Inventory Fees paid by check',
          BUTTON: null
        },
        HEIR: {
          STATUS: 'Inventory Fees paid by check',
          BUTTON: null
        },
        ATTORNEY: {
          STATUS: 'Inventory Fees paid by check',
          BUTTON: null
        }
      }

    },
    INVENTORY_AMOUNT_PAID: {

      TWOTHREE: {

        GUARDIAN: {
          STATUS: 'Inventory Fees Paid',
          BUTTON: null
        },
        CLERK: {
          STATUS: 'Inventory Fees paid',
          BUTTON: null
        },
        PETITIONER: {
          STATUS: 'Inventory Fees Paid',
          BUTTON: null
        },
        ATTORNEY: {
          STATUS: 'Inventory Fees Paid',
          BUTTON: null
        },
        HEIR: {
          STATUS: 'Inventory Fees Paid',
          BUTTON: null
        }

      },
      TWOFOUR: {

        GUARDIAN: {
          STATUS: 'Inventory Fees Paid',
          BUTTON: null
        },
        CLERK: {
          STATUS: 'Inventory Fees paid',
          BUTTON: null
        },
        PETITIONER: {
          STATUS: 'Inventory Fees Paid',
          BUTTON: null
        },
        ATTORNEY: {
          STATUS: 'Inventory Fees Paid',
          BUTTON: null
        },
        HEIR: {
          STATUS: 'Inventory Fees Paid',
          BUTTON: null
        }

      },
      THREEFOUR: {

        GUARDIAN: {
          STATUS: 'Inventory Fees Paid',
          BUTTON: null
        },
        CLERK: {
          STATUS: 'Inventory Fees paid',
          BUTTON: null
        },
        PETITIONER: {
          STATUS: 'Inventory Fees Paid',
          BUTTON: null
        },
        ATTORNEY: {
          STATUS: 'Inventory Fees Paid',
          BUTTON: null
        },
        HEIR: {
          STATUS: 'Inventory Fees Paid',
          BUTTON: null
        }

      },
      TWOEIGHT: {

        GUARDIAN: {
          STATUS: 'Inventory Fees Paid',
          BUTTON: null
        },
        CLERK: {
          STATUS: 'Inventory Fees paid',
          BUTTON: null
        },
        PETITIONER: {
          STATUS: 'Inventory Fees Paid',
          BUTTON: null
        },
        ATTORNEY: {
          STATUS: 'Inventory Fees Paid',
          BUTTON: null
        },
        HEIR: {
          STATUS: 'Inventory Fees Paid',
          BUTTON: null
        }

      },
      THREEFIVE: {

        GUARDIAN: {
          STATUS: 'Inventory Fees Paid',
          BUTTON: null
        },
        CLERK: {
          STATUS: 'Inventory Fees paid',
          BUTTON: null
        },
        PETITIONER: {
          STATUS: 'Inventory Fees Paid',
          BUTTON: null
        },
        ATTORNEY: {
          STATUS: 'Inventory Fees Paid',
          BUTTON: null
        },
        HEIR: {
          STATUS: 'Inventory Fees Paid',
          BUTTON: null
        }
      }

    },
    INVENTORY_AMOUNT_SUBMITTED: {

      TWOTHREE: {

        GUARDIAN: {
          STATUS: 'Pay Inventory Fees',
          BUTTON: 'PAY'
        },
        CLERK: {
          STATUS: 'Waiting for Inventory fees',
          BUTTON: null
        },
        PETITIONER: {
          STATUS: 'Pay Inventory Fees',
          BUTTON: 'PAY'
        },
        ATTORNEY: {
          STATUS: 'Pay Inventory Fees',
          BUTTON: 'PAY'
        },
        HEIR: {
          STATUS: 'Waiting for Inventory fees from petitioner',
          BUTTON: null
        }

      },
      TWOFOUR: {

        GUARDIAN: {
          STATUS: 'Pay Inventory Fees',
          BUTTON: 'PAY'
        },
        CLERK: {
          STATUS: 'Waiting for Inventory fees',
          BUTTON: null
        },
        PETITIONER: {
          STATUS: 'Pay Inventory Fees',
          BUTTON: 'PAY'
        },
        ATTORNEY: {
          STATUS: 'Pay Inventory Fees',
          BUTTON: 'PAY'
        },
        HEIR: {
          STATUS: 'Waiting for Inventory fees from petitioner',
          BUTTON: null
        }

      },
      THREEFOUR: {

        GUARDIAN: {
          STATUS: 'Pay Inventory Fees',
          BUTTON: 'PAY'
        },
        CLERK: {
          STATUS: 'Waiting for Inventory fees',
          BUTTON: null
        },
        PETITIONER: {
          STATUS: 'Pay Inventory Fees',
          BUTTON: 'PAY'
        },
        ATTORNEY: {
          STATUS: 'Pay Inventory Fees',
          BUTTON: 'PAY'
        },
        HEIR: {
          STATUS: 'Waiting for Inventory fees from petitioner',
          BUTTON: null
        }

      },
      TWOEIGHT: {

        GUARDIAN: {
          STATUS: 'Pay Inventory Fees',
          BUTTON: 'PAY'
        },
        CLERK: {
          STATUS: 'Waiting for Inventory fees',
          BUTTON: null
        },
        PETITIONER: {
          STATUS: 'Pay Inventory Fees',
          BUTTON: 'PAY'
        },
        ATTORNEY: {
          STATUS: 'Pay Inventory Fees',
          BUTTON: 'PAY'
        },
        HEIR: {
          STATUS: 'Waiting for Inventory fees from petitioner',
          BUTTON: null
        }

      },
      THREEFIVE: {

        GUARDIAN: {
          STATUS: 'Pay Inventory Fees',
          BUTTON: 'PAY'
        },
        CLERK: {
          STATUS: 'Waiting for Inventory fees',
          BUTTON: null
        },
        PETITIONER: {
          STATUS: 'Pay Inventory Fees',
          BUTTON: 'PAY'
        },
        ATTORNEY: {
          STATUS: 'Pay Inventory Fees',
          BUTTON: 'PAY'
        },
        HEIR: {
          STATUS: 'Waiting for Inventory fees from petitioner',
          BUTTON: null
        }
      }

    },
    UPLOAD_JUDGE_SIGNED: {

      TWOTHREE: {

        GUARDIAN: {
          STATUS: 'Waiting for Judge signed 2.3',
          BUTTON: null
        },
        CLERK: {
          STATUS: 'Upload Judge signed 2.3',
          BUTTON: 'Upload'
        },
        JUDGE: {
          STATUS: 'Upload Judge signed 2.3',
          BUTTON: 'Upload'
        },
        PETITIONER: {
          STATUS: 'Waiting for Judge signed 2.3',
          BUTTON: null
        },
        ATTORNEY: {
          STATUS: 'Waiting for Judge signed 2.3',
          BUTTON: null
        },
        HEIR: {
          STATUS: 'Waiting for Judge signed 2.3',
          BUTTON: null
        }

      },
      TWOFOUR: {

        GUARDIAN: {
          STATUS: 'Waiting for Judge signed 2.3',
          BUTTON: null
        },
        CLERK: {
          STATUS: 'Upload Judge signed 2.3',
          BUTTON: 'Upload'
        }

      },
      THREEFOUR: {

        GUARDIAN: {
          STATUS: 'Waiting for Judge signed 2.3',
          BUTTON: null
        },
        CLERK: {
          STATUS: 'Upload Judge signed 2.3',
          BUTTON: 'Upload'
        }

      },
      TWOEIGHT: {

        GUARDIAN: {
          STATUS: 'Waiting for Judge signed 2.3',
          BUTTON: null
        },
        CLERK: {
          STATUS: 'Upload Judge signed 2.3',
          BUTTON: 'Upload'
        }

      },
      THREEFIVE: {

        GUARDIAN: {
          STATUS: 'Waiting for Judge signed 2.3',
          BUTTON: null
        },
        CLERK: {
          STATUS: 'Upload Judge signed 2.3',
          BUTTON: 'Upload'
        }
      }

    },

    SET_JUDGEMENT:{
      TWOTHREE: {
        CLERK: {
          STATUS: 'Hearing date set',
          BUTTON: 'Judgement'
        },
        PETITIONER: {
          STATUS: 'Waiting for judgement',
          BUTTON: null
        },
        GUARDIAN: {
          STATUS: 'Waiting for judgement',
          BUTTON: null
        },
        JUDGE: {
          STATUS: 'Hearing date set',
          BUTTON: 'Judgement'
        },
        HEIR: {
          STATUS: 'Waiting for judgement',
          BUTTON: null
        },
        ATTORNEY: {
          STATUS: 'Waiting for judgement',
          BUTTON: null
        },
        GUARDIANADLITEM: {
          STATUS: 'Waiting for judgement',
          BUTTON: null
        }
      }
    },
    WAITING_FOR_GUARDIAN:{
      THREEFOUR: {
        PETITIONER: {
          STATUS: 'Waiting for guardian',
          BUTTON: null
        },
        HEIR: {
          STATUS: 'Waiting for guardian',
          BUTTON: null
        },
        ATTORNEY: {
          STATUS: 'Waiting for guardian',
          BUTTON: null
        },
        GUARDIAN: {
          STATUS: 'Accept / Deny ',
          BUTTON: 'Accept / Deny'
        }
      }
    }
    ,
    null: {

      TWOTHREE: {

        CLERK: {
          STATUS: 'Needs submission',
          BUTTON: null
        },
        PETITIONER: {
          STATUS: 'Needs submission',
          BUTTON: null
        },
        GUARDIAN: {
          STATUS: 'Needs submission',
          BUTTON: 'File'
        },
        HEIR: {
          STATUS: 'Needs submission',
          BUTTON: null
        },
        ATTORNEY: {
          STATUS: 'Needs submission',
          BUTTON: null
        }

      },
      THREEFIVE : {

        CLERK: {
          STATUS: 'Needs submission',
          BUTTON: null
        },
        PETITIONER: {
          STATUS: 'Needs submission',
          BUTTON: null
        },
        GUARDIAN: {
          STATUS: 'Needs submission',
          BUTTON: 'File'
        },
        HEIR: {
          STATUS: 'Needs submission',
          BUTTON: null
        },
        ATTORNEY: {
          STATUS: 'Needs submission',
          BUTTON: null
        }

      },
      TWOFOUR: {

        CLERK: {
          STATUS: 'Needs submission',
          BUTTON: null
        },
        PETITIONER: {
          STATUS: 'Needs submission',
          BUTTON: null
        },
        GUARDIAN: {
          STATUS: 'Needs submission',
          BUTTON: 'File'
        },
        HEIR: {
          STATUS: 'Needs submission',
          BUTTON: null
        },
        ATTORNEY: {
          STATUS: 'Needs submission',
          BUTTON: null
        }

      },
      THREEFOUR: {

        CLERK: {
          STATUS: 'Needs submission',
          BUTTON: null
        },
        PETITIONER: {
          STATUS: 'Needs submission',
          BUTTON: null
        },
        GUARDIAN: {
          STATUS: 'Needs submission',
          BUTTON: 'File'
        },
        HEIR: {
          STATUS: 'Needs submission',
          BUTTON: null
        },
        ATTORNEY: {
          STATUS: 'Needs submission',
          BUTTON: null
        }

      },
      TWOEIGHT: {

        CLERK: {
          STATUS: 'Needs submission',
          BUTTON: null
        },
        PETITIONER: {
          STATUS: 'Needs submission',
          BUTTON: null
        },
        GUARDIAN: {
          STATUS: 'Needs submission',
          BUTTON: 'File'
        },
        HEIR: {
          STATUS: 'Needs submission',
          BUTTON: null
        },
        ATTORNEY: {
          STATUS: 'Needs submission',
          BUTTON: null
        }

      },
      SEVENONE: {

        CLERK: {
          STATUS: 'Needs submission',
          BUTTON: null
        },
        PETITIONER: {
          STATUS: 'Needs submission',
          BUTTON: null
        },
        GUARDIAN: {
          STATUS: 'Needs submission',
          BUTTON: 'File'
        },
        HEIR: {
          STATUS: 'Needs submission',
          BUTTON: null
        },
        ATTORNEY: {
          STATUS: 'Needs submission',
          BUTTON: null
        }

      },
      NINETWO : {

        CLERK: {
          STATUS: 'Needs submission',
          BUTTON: null
        },
        PETITIONER: {
          STATUS: 'Needs submission',
          BUTTON: 'File'
        },
        GUARDIAN: {
          STATUS: 'Needs submission',
          BUTTON: null
        },
        HEIR: {
          STATUS: 'Needs submission',
          BUTTON: null
        },
        ATTORNEY: {
          STATUS: 'Needs submission',
          BUTTON: 'File'
        }

      }

    }

  };

  listOfStatus = [
    'FILED_FOR_CLERK',
    'UPLOAD_FILED_FOR_CLERK',
    'NEEDS_UPLOAD_FROM_CLERK',
    'NEEDS_UPLOAD_FROM_JUDGE',
    'FILED_FOR_JUDGE'
  ];

  openCaseStatuses = [
    'FILED_FOR_CLERK',
    'FILED_FOR_JUDGE',
    'APPROVED_BY_CLERK',
    'DENIED_BY_CLERK',
    'DENIED_BY_JUDGE',
    'NEEDS_UPLOAD_FROM_CLERK',
    'NEEDS_UPLOAD_FROM_JUDGE',
    'NEEDS_UPLOAD_FROM_PETITIONER',
    'UPLOAD_DENIED_BY_CLERK',
    'UPLOAD_DENIED_BY_JUDGE',
    'UPLOAD_APPROVED_BY_CLERK',
    'UPLOAD_APPROVED_BY_JUDGE',
    'UPLOAD_FILED_FOR_CLERK',
    'UPLOAD_FILED_FOR_JUDGE'
  ];

  public getStatusText(userRole: string, status: string, form: string) {
    return this.getStatus(userRole, status, form, 'STATUS');
  }

  public getUploadStatus() {
    return [
      'NEEDS_UPLOAD_FROM_JUDGE',
      'NEEDS_UPLOAD_FROM_CLERK',
      'NEEDS_UPLOAD_FROM_PETITIONER',
      'NEEDS_UPLOAD_FROM_GUARDIAN',
      'UPLOAD_DENIED_BY_CLERK',
      'UPLOAD_DENIED_BY_JUDGE'
    ];
  }

  public getLongForm(status) {
    switch (status) {
      case '2.3':
        return 'TWOTHREE';
      case '2.4':
        return 'TWOFOUR';
      case '3.4':
        return 'THREEFOUR';
      case '2.8':
        return 'TWOEIGHT';
      case '7.1':
        return 'SEVENONE';
      case '3.5':
        return 'THREEFIVE';
      default:
        return status;
    }
  }

  public getButtonText(userRole: string, status: string, form: string) {
    return this.getStatus(userRole, this.getLongForm(status), form, 'BUTTON');
  }

  public getStatus(userRole: string, status: string, form: string, type: string) {

    let st;

    status = this.getLongForm(status);

    if (this.STATUS && this.STATUS[status] && this.STATUS[status][form] && this.STATUS[status][form][userRole]) {
      st = this.STATUS[status][form][userRole][type];
    }

    if (st === undefined) {
      return 'NULL';
    }

    return st;

  }

}



// WEBPACK FOOTER //
// ./src/app/main/shared/services/status.service.ts